import Grid from '@components/Grid'
import { Reviews, ReviewsItem, ReviewsList } from '@components/Reviews'
import Section, { SectionHeadline } from '@components/Section'
import Blockquote from '@components/UI/Blockquote'
import Container from '@components/UI/Container'
import Icon from '@components/UI/Icon'
import Link from '@components/UI/Link'
import Heading from '@components/UI/Typography/Heading'

import React from 'react'

import reviewsData from './reviews'

const DemoReviews = () => {
    const { rates, services } = reviewsData

    return (
        <Container>
            <div className='mb-48p'>
                <SectionHeadline>
                    <Heading
                        tag='h2'
                        mods={ { 'text-center': true } }
                    >
                        Traqq always gets rave reviews!
                    </Heading>
                </SectionHeadline>

                <Reviews>
                    <ul className='flex flex-wrap gap-x-10p gap-y-24p justify-center 768:gap-x-20p 1280:gap-x-32p'>
                        { rates.map(item =>
                            <li
                                className='w-130p 480:w-138p'
                                key={ item.id }
                            >
                                { /* eslint-disable-next-line @next/next/no-img-element */ }
                                <Link href={ item.link } target='_blank'>
                                    <img
                                        src={ item.src }
                                        alt={ item.alt }
                                        // style={ item.style }
                                    />
                                </Link>
                            </li>
                        ) }
                    </ul>
                </Reviews>
            </div>

            <div
                className='flex flex-col gap-20p 768:flex-row'
            >
                { services.map((review, index) =>
                    <div
                        key={ index }
                        className={ `flex flex-col p-24p gap-y-24p rounded-24p basis-full ${ review.bg } 1024:p-40p` }
                    >
                        <Icon
                            name='quote'
                            color={ review.iconColor }
                            size={ 32 }
                            className='!block'
                        />

                        <h3>
                            “
                            { review.body }
                            ”
                        </h3>

                        <div className='flex flex-col gap-8p mt-auto 480:flex-row 480:items-center'>
                            <h4>
                                { review.author }
                                &nbsp;
                                <span className='desktop-body-2'>from</span>
                            </h4>

                            <img
                                src={ review.logo.image }
                                alt={ review.logo.alt }
                                width={ review.logo.width || 108 }
                            />
                        </div>
                    </div>
                ) }
            </div>
        </Container>
    )
}

export default DemoReviews
